import api from './client';

export type TagCategory = {
  id: number;
  code: string;
  name: string;
};

export type TagItem = {
  id: number;
  category_id: number;
  category_code: string;
  category_name: string;
  label: string;
  color: string;
  is_active: number;
  created_on: string;
  updated_on: string;
};

export type TagAssignmentItem = TagItem & {
  assigned: number;
};

export type TagPayload = {
  category_id: number;
  label: string;
  color: string;
  is_active: number;
};

export async function fetchTagCategories(): Promise<TagCategory[]> {
  const res = await api.get<TagCategory[]>('/tags/categories');
  return res.data;
}

export async function fetchTags(categoryId?: number): Promise<TagItem[]> {
  const res = await api.get<TagItem[]>('/tags', {
    params: categoryId ? { category_id: categoryId } : undefined,
  });
  return res.data;
}

export async function createTag(payload: TagPayload): Promise<void> {
  await api.post('/tags', payload);
}

export async function updateTag(id: number, payload: TagPayload): Promise<void> {
  await api.put(`/tags/${id}`, payload);
}

export async function deleteTag(id: number): Promise<void> {
  await api.delete(`/tags/${id}`);
}

export async function fetchTagAssignments(categoryCode: string, objectId: number): Promise<TagAssignmentItem[]> {
  const res = await api.get<TagAssignmentItem[]>('/tags/assignments', {
    params: {
      category_code: categoryCode,
      object_id: objectId,
    },
  });
  return res.data;
}

export async function updateTagAssignments(categoryCode: string, objectId: number, tagIds: number[]): Promise<void> {
  await api.put('/tags/assignments', {
    category_code: categoryCode,
    object_id: objectId,
    tag_ids: tagIds,
  });
}
